import { MENU } from "../../Constants/Endpoints";
import { ApiRequestInterceptor } from "../apiRequest";
import { normalizeResponse } from "../normalizeResponse";

const porId = (productoId) => MENU.productoById.replace("{productoId}", encodeURIComponent(productoId));

export const fetchCreateProducto = async (body) => {
  const response = await ApiRequestInterceptor(MENU.productos, "POST", body);
  return normalizeResponse(response, "No se pudo crear el producto");
};

export const fetchUpdateProducto = async (productoId, body) => {
  const response = await ApiRequestInterceptor(porId(productoId), "PUT", body);
  return normalizeResponse(response, "No se pudo guardar el producto");
};

export const fetchDeleteProducto = async (productoId) => {
  const response = await ApiRequestInterceptor(porId(productoId), "DELETE");
  return normalizeResponse(response, "No se pudo eliminar el producto");
};
